import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IViewUserStrings extends LocalizedStringsMethods {
    lsuserTxt: string;
    lsUsersTxt: string;
    lsUsrNameTxt: string;
    lsUsrAlreadyExistTxt: string;
    lsFNameTxt: string;
    lsLNameTxt: string;
    lsEmailTxt: string;
    lsMobilePhTxt: string;
    lsRoleTxt: string;
    lsOrgTxt: string;
    lsContactInfoTxt: string;
    lsShareHistoryTxt: string;
    lsShareTextTxt: string;
    lsPrintTxt: string;
    lsDownloadTxt: string;
    lsExportTxt: string;
    lsOkTxt: string;
    lsTestExportSuccessTxt: string;
    lsTestSharedSuccessTxt: string;
    lsTestShareFailTxt: string;
    lsShareTxt: string;
    lsExportUserTxt: string;
    lsActivatedTxt: string;
    lsDeActivatedTxt: string;
    lsUsrSuccessMsgTxt: string;
    lsAPIErrorTxt: string;
    lsShareSuccessTxt: string;
}

let strings: IViewUserStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsuserTxt: 'User',
        lsUsrNameTxt: 'Username',
        lsUsrAlreadyExistTxt: 'Username already exists!',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsMobilePhTxt: 'Mobile Phone',
        lsRoleTxt: 'Role',
        lsOrgTxt: 'Organization',
        lsUsersTxt: 'Users',
        lsEditTxt: 'Edit',
        lsContactInfoTxt: 'Contact & Notify Info',
        lsShareHistoryTxt: 'Share History',
        lsShareTextTxt: 'Share Test',
        lsPrintTxt : 'Print',
        lsDownloadTxt: 'Download',
        lsExportTxt: 'Export User List',
        lsOkTxt: 'Ok',
        lsTestExportSuccessTxt: 'Tests exported successfully!',        
        lsTestSharedSuccessTxt: 'Tests shared successfully!',
        lsTestShareFailTxt: 'Tests could not be shared.Please try again!',
        lsShareTxt: 'Share',
        lsExportUserTxt: 'Export User List',
        lsActivatedTxt: 'Activated',
        lsDeActivatedTxt: 'Deactivated',
        lsUsrSuccessMsgTxt: 'User {0} successfully!',
        lsShareSuccessTxt: 'Share {0} successfully!',
        lsAPIErrorTxt: 'Some error has occured! Please try again later',
        lsDeleteTestTxt: 'Test Deletion',
        lsAllowedTxt: 'Allowed',
        lsNotAllowedTxt: 'Not Allowed'
    },
    es: {       
        lsuserTxt: 'Usuario',
        lsUsersTxt: 'Usuarios',
        lsUsrNameTxt: 'Nombre de usuario',
        lsUsrAlreadyExistTxt: 'nombre de usuario ya existe!',
        lsFNameTxt: 'Nombre de pila',
        lsLNameTxt: 'Apellido',
        lsEmailTxt: 'Email',
        lsMobilePhTxt: 'Teléfono móvil',
        lsRoleTxt: 'Role',
        lsOrgTxt: 'Organización',
        lsEditTxt: 'Editar',
        lsContactInfoTxt: 'Contacto y notificación de información',
        lsShareHistoryTxt: 'Share History',
        lsShareTextTxt: 'Compartir prueba',
        lsPrintTxt : 'Impresión',
        lsDownloadTxt: 'Descargar',
        lsExportTxt: 'Exportar lista de Users',
        lsOkTxt: 'De acuerdo',
        lsTestExportSuccessTxt: 'Pruebas exportadas con éxito',        
        lsTestSharedSuccessTxt: '¡Pruebas compartidas exitosamente!',
        lsTestShareFailTxt: 'Las pruebas no se pudieron compartir. ¡Inténtalo de nuevo!',
        lsShareTxt: 'Share',
        lsExportUserTxt: 'Export User List',
        lsActivatedTxt: 'Activated',
        lsDeActivatedTxt: 'Deactivated',
        lsUsrSuccessMsgTxt: 'User {0} successfully!',
        lsShareSuccessTxt: 'Share {0} successfully!',
        lsAPIErrorTxt: 'Some error has occured! Please try again later',        
        lsDeleteTestTxt: 'Prueba de eliminación',
        lsAllowedTxt: 'Permitido',
        lsNotAllowedTxt: 'No permitido'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/user/strings.user.view.tsx